import { mountStandaloneApp } from '@yuksalish/ui'
import ProductDetailPage from './products/pages/ProductDetailPage.vue'
import ProductsListPage from './products/pages/ProductsListPage.vue'
import ProductFormPage from './products/pages/ProductFormPage.vue'
import TechnicalPassportDetailPage from './products/pages/TechnicalPassportDetailPage.vue'
import TechnicalPassportFormPage from './products/pages/TechnicalPassportFormPage.vue'
import CatalogItemDetailPage from './products/pages/CatalogItemDetailPage.vue'
import ProductionOrderGuidedPage from './products/pages/ProductionOrderGuidedPage.vue'
import ProductionOrdersListPage from './products/pages/ProductionOrdersListPage.vue'
import ProductionOrderDetailPage from './products/pages/ProductionOrderDetailPage.vue'
import ProductionLotsPage from './products/pages/ProductionLotsPage.vue'
import ProductionLotDetailPage from './products/pages/ProductionLotDetailPage.vue'
import ProductionDailyOutputReportPage from './products/pages/ProductionDailyOutputReportPage.vue'
import BomEditorPage from './products/pages/BomEditorPage.vue'
import { engineeringMessages } from './i18n'

mountStandaloneApp({
  code: 'engineering',
  title: 'Texnologiya va muhandislik',
  description: 'Mahsulot ta’riflari, BOM versiyalari, texnologik yo‘nalishlar va texnik pasportlar.',
  messages: engineeringMessages,
  accent: '#3568a8',
  navigation: [
    {
      label: {
        en: engineeringMessages.en.engineering.nav.products,
        ru: engineeringMessages.ru.engineering.nav.products,
        uz: engineeringMessages.uz.engineering.nav.products,
      },
      to: '/products',
      permission: 'products.view',
    },
    {
      label: {
        en: engineeringMessages.en.engineering.nav.rawMaterials,
        ru: engineeringMessages.ru.engineering.nav.rawMaterials,
        uz: engineeringMessages.uz.engineering.nav.rawMaterials,
      },
      to: '/raw-materials',
      permission: 'products.view',
    },
    {
      label: {
        en: engineeringMessages.en.engineering.nav.spareParts,
        ru: engineeringMessages.ru.engineering.nav.spareParts,
        uz: engineeringMessages.uz.engineering.nav.spareParts,
      },
      to: '/spare-parts',
      permission: 'products.view',
    },
    {
      label: {
        en: engineeringMessages.en.engineering.nav.productionOrders,
        ru: engineeringMessages.ru.engineering.nav.productionOrders,
        uz: engineeringMessages.uz.engineering.nav.productionOrders,
      },
      to: '/production-orders',
      permission: 'production_orders.view',
    },
    {
      label: {
        en: engineeringMessages.en.engineering.nav.dailyOutput,
        ru: engineeringMessages.ru.engineering.nav.dailyOutput,
        uz: engineeringMessages.uz.engineering.nav.dailyOutput,
      },
      to: '/production-reports/daily-output',
      permission: 'production_orders.view',
    },
  ],
  requiredPermissions: ['products.view'],
  routes: [
    {
      path: '',
      redirect: '/products',
    },
    {
      path: 'products',
      component: ProductsListPage,
      meta: { permission: 'products.view' },
    },
    {
      path: 'raw-materials',
      component: ProductsListPage,
      meta: {
        permission: 'products.view',
        catalogKind: 'raw-materials',
      },
    },
    {
      path: 'raw-materials/:id',
      component: CatalogItemDetailPage,
      meta: {
        permission: 'products.view',
        catalogKind: 'raw-materials',
      },
    },
    {
      path: 'raw-materials/new',
      component: ProductFormPage,
      meta: {
        permission: 'products.manage',
        catalogKind: 'raw-materials',
      },
    },
    {
      path: 'raw-materials/:id/edit',
      component: ProductFormPage,
      meta: {
        permission: 'products.manage',
        catalogKind: 'raw-materials',
      },
    },
    {
      path: 'spare-parts',
      component: ProductsListPage,
      meta: {
        permission: 'products.view',
        catalogKind: 'spare-parts',
      },
    },
    {
      path: 'spare-parts/:id',
      component: CatalogItemDetailPage,
      meta: {
        permission: 'products.view',
        catalogKind: 'spare-parts',
      },
    },
    {
      path: 'spare-parts/new',
      component: ProductFormPage,
      meta: {
        permission: 'products.manage',
        catalogKind: 'spare-parts',
      },
    },
    {
      path: 'spare-parts/:id/edit',
      component: ProductFormPage,
      meta: {
        permission: 'products.manage',
        catalogKind: 'spare-parts',
      },
    },
    {
      path: 'products/:id',
      component: ProductDetailPage,
      meta: { permission: 'products.view' },
    },
    {
      path: 'products/new',
      component: ProductFormPage,
      meta: { permission: 'products.manage' },
    },
    {
      path: 'products/:id/edit',
      component: ProductFormPage,
      meta: { permission: 'products.manage' },
    },
    {
      path: 'products/:id/bom/new',
      component: BomEditorPage,
      meta: { permission: 'bom.manage' },
    },
    {
      path: 'products/:id/bom/:bomId/edit',
      component: BomEditorPage,
      meta: { permission: 'bom.manage' },
    },
    {
      path: 'technical-passports/new',
      component: TechnicalPassportFormPage,
      meta: { permission: 'production_orders.manage' },
    },
    {
      path: 'technical-passports/:id/edit',
      component: TechnicalPassportFormPage,
      meta: { permission: 'production_orders.manage' },
    },
    {
      path: 'technical-passports/:id',
      component: TechnicalPassportDetailPage,
      meta: { permission: 'production_orders.view' },
    },
    {
      path: 'production-orders/new-guided',
      component: ProductionOrderGuidedPage,
      meta: { permission: 'production_orders.manage' },
    },
    { path: 'production-orders', component: ProductionOrdersListPage, meta: { permission: 'production_orders.view' } },
    { path: 'production-reports/daily-output', component: ProductionDailyOutputReportPage, meta: { permission: 'production_orders.view' } },
    { path: 'production-orders/:id', component: ProductionOrderDetailPage, meta: { permission: 'production_orders.view' } },
    { path: 'production-orders/:id/stages', component: ProductionOrderDetailPage, meta: { permission: 'production_orders.view' } },
    { path: 'production-orders/:id/lots', component: ProductionLotsPage, meta: { permission: 'production_orders.view' } },
    { path: 'production-orders/:id/lots/:lotNumber', component: ProductionLotDetailPage, meta: { permission: 'production_orders.view' } },
  ],
})
